'use client';
import {MagnifyingGlassIcon} from '@navikt/aksel-icons';
import {LinkButton} from 'common/components/link-button';
import {useTranslation} from 'react-i18next';

export const BackToSearchButton = ({type}: {type: 'virksomhet' | 'person' | 'motorvogn' | 'ektepakt'}) => {
  const {t} = useTranslation('common');
  return (
    <LinkButton
      variant='primary'
      data-transaction-name='new-search'
      id='new-search'
      test-id='search-button'
      href={`/oppslag#${type}`}
      icon={<MagnifyingGlassIcon />}
      iconAfter
    >
      {t('common:back-to-search')}
    </LinkButton>
  );
};
